export default __webpack_public_path__ + "static/singapore-sme-sales-crm-img-4e236328639824b1d423aafc0d4a56bf.png";